import React, { FCX, ReactNode } from 'react';
import styled from '@emotion/styled';

import FlexCenteringBox from 'src/styles/flex-centering-box';

interface Props {
  color: string;
  shifts?: boolean;
  onClick?: (event?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  icon: ReactNode;
  title: string;
}

const Component: FCX<Props> = ({ children, className, onClick, icon, title }) => (
  <FlexCenteringBox className={className} onClick={onClick}>
    {icon}
    <div>{title}</div>
  </FlexCenteringBox>
);

const StyledComponent = styled(Component)`
  position: relative;
  overflow: hidden;
  width: 90px;
  height: 90px;
  padding: 10px;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
  background-color: ${({ color }) => color};
  ${({ shifts }) => (shifts ? 'margin-top: 2.5em;' : '')};
  font-weight: 600;

  svg {
    width: 60%;
    fill: #fff;
  }

  div {
    color: var(--color-text-inverse);
    text-align: center;
  }

  @media only screen and (min-width: 700px) {
    width: 120px;
    height: 120px;
  }

  @media only screen and (min-width: 1024px) {
    width: 180px;
    height: 180px;
    padding: 28px;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: all 0.4s ease;
      border: 2px solid transparent;
    }

    &:hover:before {
      top: 10px;
      left: 10px;
      width: calc(100% - 20px);
      height: calc(100% - 20px);
      border: 2px solid var(--color-text-inverse);
    }
  }
`;

export default StyledComponent;
